import React from 'react';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import Dialog from './Dialog';

const ViewPicker = (props) => {
  const { viewType, challengeFlowCollection } = useIdentityChallengeContext();

  // Only show a modal if a challenge flow has been initialized
  if (!challengeFlowCollection) {
    return null;
  }

  switch (viewType) {
    case 'dialog':
      return (
        <Dialog {...props} />
      );
    default:
      throw new Error('viewType not set when attempting to show a challenge flow');
  }
};


export default ViewPicker;
